import { useEffect } from 'react';
// @ts-expect-error Untyped import
import ReportsTable from '../ReportsTable';
import { LeftIcon } from 'foundations-assets';
import { useSelector, useDispatch } from 'react-redux';
// @ts-expect-error Untyped import
import { selectTableData } from '../../selectors/tableData';
// @ts-expect-error Untyped import
import { trackEvent, EVENTS } from '../../lib/usageTracker';
import { Flex } from 'foundations-components/components/Flex';
import { ReportsViewContainer } from '../ReportsViewContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped import
import { setReportsFilters } from '../../actions/reportsActions';
// @ts-expect-error Untyped import
import { selectFilters } from '../../selectors/reportsSelector';
import ShowMoreButton from '../../components/common/ShowMoreButton';
import AsyncReportsListSubHeader from '../AsyncReportsListSubHeader';
import { Link } from 'foundations-components/transitional/components/Link';
import { Section } from 'foundations-components/transitional/components/Section';
import { getIsUngatedToReportListViewToggle } from '../../selectors/gatesSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const MyReportsSearchSection = ({
  search,
  showMore,
  setShowMore
}) => {
  const dispatch = useDispatch();
  const tableData = useSelector(selectTableData);
  const filters = useSelector(selectFilters).toJS();
  const isUngatedToReportListViewToggle = useSelector(getIsUngatedToReportListViewToggle);
  useEffect(() => {
    if (showMore) {
      trackEvent(EVENTS.clickShowMoreSearchResults, {
        filterValue: search,
        action: 'show-more-my-reports',
        subscreen: 'global-search'
      });
    }
  }, [showMore, search]);
  const handleBackToAllResultsClick = () => {
    // go back to first page of results
    // before truncating the table
    if (filters.offset > 0) {
      dispatch(setReportsFilters(Object.assign({}, filters, {
        offset: 0
      })));
    }
    setShowMore(false);
  };
  const handleShowMoreClick = () => {
    setShowMore(true);
  };
  return /*#__PURE__*/_jsxs(Section, {
    marginBlockEnd: "800",
    children: [showMore && /*#__PURE__*/_jsxs(Flex, {
      marginBlockEnd: "500",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(LeftIcon, {
        color: "icon-interactive-default"
      }), /*#__PURE__*/_jsx(Link, {
        onClick: handleBackToAllResultsClick,
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.globalSearch.backToAllResults"
        })
      })]
    }), isUngatedToReportListViewToggle ? /*#__PURE__*/_jsx(ReportsViewContainer, {
      isSearch: true,
      showPreview: !showMore
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(AsyncReportsListSubHeader, {
        isSearch: true
      }), /*#__PURE__*/_jsx(ReportsTable, {
        showPreview: !showMore
      })]
    }), (tableData === null || tableData === void 0 ? void 0 : tableData.size) > 3 && !showMore && /*#__PURE__*/_jsx(ShowMoreButton, {
      handleClickShowMoreButton: handleShowMoreClick,
      translationKey: "reports.globalSearch.seeAll"
    })]
  });
};
export default MyReportsSearchSection;